export const environment = {
  production: false,
  envName: 'dev',
  appBaseUrl: 'https://upsize.agileinteractive.eu',
  supabaseUrl: 'https://pfwcxdxirnnfcfdfevae.supabase.co',
  supabaseAnonKey: 'sb_publishable_e3ulS3qZxOz0eee-Z0rm_w_fC8lNnPK',
  azureTenantId: 'c2a30827-5e46-4ea5-ae94-87f923ef4a34',
  azureClientId: '39163634-a44f-49d6-a451-52d574135b54',
  filesServiceUrl: 'https://upsize.dfs.agileinteractive.eu',
  adobePdfClientId: 'c1392089c1de4d33a7a880a160990d1c',
  emailSenderDomain: 'upsize.agileinteractive.eu',
  dropboxHomeBaseUrl: 'https://www.dropbox.com/home',
  sellsyOpportunityBaseUrl: 'https://www.sellsy.com/prospection/opportunities',
  sellsyEstimateBaseUrl: 'https://www.sellsy.com/?_f=estimateOverview&id=',
  microsoftLoginBaseUrl: 'https://login.microsoftonline.com',
  addressApiBaseUrl: 'https://api-adresse.data.gouv.fr',
  adobeSdkUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
};
